import { Navigate } from 'react-router-dom';

import useScreenSize from '@/hooks/useScreenSize';
import useTranslations from '@/i18n/useTranslations';
import ActivityMenu from '@/layouts/navigation/user-activity/components/ActivityMenu';
import ActivityHeading from '@/shared-components/text/components/ActivityHeading';

export default function ActivityIndex() {
  const t = useTranslations('common.profile.activity');
  const screenSize = useScreenSize();

  if(screenSize.width > 700) {
    return <Navigate to="/profile/activity/liked-artworks" replace/>;
  }

  return (
    <>
      <ActivityHeading text={t('heading')} to="/profile"/>
      <ActivityMenu/>
    </>
  );
}
